import { motion, AnimatePresence } from 'motion/react';
import GradientText from '../GradientText/GradientText';
import styles from './BannerHome.module.css';
import { getImageUrl } from '../../utils/imageHelper';
import { useState, useEffect } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const bannerImages = [
  {
    src: getImageUrl('./img/banner-black.jpg'),
    srcMobile: getImageUrl('./img/banner-web-negros-mob.jpg'),
    alt: 'Banner Black'
  },
  {
    src: getImageUrl('./img/banner-web-2026.jpg'),
    srcMobile: getImageUrl('./img/banner-web-esteriles-mob.jpg'),
    alt: 'Banner Web 2026'
  },
  {
    src: getImageUrl('./img/banner-web-2026-esteriles.jpg'),
    srcMobile: getImageUrl('./img/banner-web-blue-mob.jpg'),
    alt: 'Banner Web 2026 Estériles'
  }
];

function BannerHome() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const goToPrevious = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? bannerImages.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % bannerImages.length);
  };

  return (
    <section className={styles.bannerSection}>
      <div className={styles.header}>
        <GradientText
          colors={['#8ec9c3', '#c9298e', '#8ec9c3']}
          animationSpeed={6.5}
          direction="horizontal"
          yoyo
          className={styles.starIconWrapper}
        >
          <span className={styles.starIcon} aria-hidden="true">★</span>
        </GradientText>

        <h2 className={styles.subtitle}>Novedades</h2>
      </div>

      <div className={styles.sliderWrapper}>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            className={styles.bannerContainer}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: 'easeInOut' }}
          >
            <img
              src={isMobile ? bannerImages[currentIndex].srcMobile : bannerImages[currentIndex].src}
              alt={bannerImages[currentIndex].alt}
              className={styles.bannerImage}
            />
          </motion.div>
        </AnimatePresence>

        <button 
          className={styles.navButton + ' ' + styles.prevButton}
          onClick={goToPrevious}
          aria-label="Imagen anterior"
        >
          <FiChevronLeft size={24} />
        </button>

        <button 
          className={styles.navButton + ' ' + styles.nextButton}
          onClick={goToNext}
          aria-label="Siguiente imagen"
        >
          <FiChevronRight size={24} />
        </button>

        <div className={styles.dotsContainer}>
          {bannerImages.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Ir a imagen ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default BannerHome;

